import React from 'react'

const BarraDePasos = (props) => {

        return (
          <div className="breadcrumbs">
           <ul className="row">
             <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
               <div className={"number " + (props.paso === 1 ? 'active' : '')}>
                 <span>1</span>
                 <hr />
               </div>
               <p className={props.paso === 1 ? 'text-active' : ''}>Log-in</p>
             </li>
             <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
               <div className={"number " + (props.paso === 2 ? 'active' : '')}>
                 <span>2</span>
                 <hr />
               </div>
               <p className={props.paso === 2 ? 'text-active' : ''}>Carga de pasajeros</p>
             </li>
             <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
               <div className={"number " + (props.paso === 3 ? 'active' : '')}>
                 <span>3</span>
                 <hr />
               </div>
               <p className={props.paso === 3 ? 'text-active' : ''}>Pago</p>
             </li>
             <li className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
               <div className={"number " + (props.paso === 4 ? 'active' : '')}>
                 <span>4</span>
                 <hr />
               </div>
               <p className={props.paso === 4 ? 'text-active' : ''}>Fin de la compra</p>
             </li>
           </ul>
         </div>
              );

}

export default BarraDePasos



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/BarraDePasos.js